export default {
  load(obj) {
    if (document.getElementById(obj.id)) {
      return
    }
    const sc = document.createElement('script')
    sc.id = obj.id
    sc.src = obj.src

    document.head.appendChild(sc)
  },
  loadasync(obj) {
    return new Promise(function (resolve, reject) {
      let sc = document.getElementById(obj.id)
      if (sc != null) {
        resolve(sc)
      }
      sc = document.createElement('script')
      sc.id = obj.id
      sc.src = obj.src

      sc.onload = () => resolve(sc)
      sc.onerror = () => reject(new Error('script load error'))

      document.head.appendChild(sc)
    })
  },
}
